import "../src/App.css"
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import OurCourse from "./components/OurCourse";
import OurTeam from "./components/OurTeam";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ContactUs from "./components/ContactUs";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/ourcourse" element={<OurCourse />}></Route>
          <Route path="/ourteam" element={<OurTeam />}></Route>
          <Route path="/contactus" element={<ContactUs />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
